global.jsonld = global.jsonld || null
global.jsonldjs = global.jsonldjs || null
